import { jsx as t } from "@emotion/react/jsx-runtime";
import { SelectableCardContainer as n } from "./SelectableCard.styled.js";
import { HorizontalCard as o } from "./HorizontalCard/HorizontalCard.js";
import { CheckButton as l } from "./CheckButton/CheckButton.js";
const i = (e) => {
  switch (e.type) {
    case "checkButton":
      return /* @__PURE__ */ t(l, { ...e });
    case "horizontal":
      return /* @__PURE__ */ t(o, { ...e });
    default:
      return null;
  }
}, h = (e) => {
  const {
    disabled: r,
    checked: a,
    className: c
  } = e;
  return /* @__PURE__ */ t(n, { "aria-disabled": r, "aria-checked": a, className: c, children: /* @__PURE__ */ t(i, { ...e }) });
};
export {
  h as SelectableCard
};
